module.exports = __webpack_public_path__ + "img/8.f5bc0a28.jpg";